/* Copyright (C) 2016 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */
import CrmPropertiesProvider from './CrmPropertiesProvider';

let def: any =
{
	__init__:
	[
		'propertiesProvider'
	],
	propertiesProvider: [ 'type', CrmPropertiesProvider ]
};

export default def;
